import React, { useLayoutEffect } from 'react';
import GLP1Management from '../../component/glp_1/GLP1Management';
import { Card } from 'antd';
import HeaderCompo from '../../component/Header';

const GLP1ManagementScreen = ({ handleColorChange }) => {
  useLayoutEffect(() => {
    handleColorChange("#000833");
  }, []);

  return (
    <div>
     <HeaderCompo initialColor={'#000833'} /> 
      
      {/* <Card 
        title="GLP1 Management" 
        className="custom-card border"
      > */}
        {/* <div className="flex flex-col gap-3"> */}
          <GLP1Management />
        {/* </div> */}
      {/* </Card> */}
    </div>
  );
};

export default GLP1ManagementScreen;